import { Injectable } from '@angular/core';

export type ErrorTypes = keyof typeof ERROR_MESSAGES;

const ERROR_MESSAGES: { [key: string]: (fieldName: string, error?: any) => string } = {
    required: (fieldName) => `${fieldName} is required`,
    minDate: () => 'Date is too early.',
    email: () => 'Invalid email address.',
    pattern: (formControlName: string) => `${formControlName} format is not valid.`,
    min: (fieldName, error) => `${fieldName} value must be at least ${error.min}.`,
    max: (fieldName, error) => `${fieldName} value cannot exceed ${error.max}.`,
    minlength: (fieldName, error) => `${fieldName} must be at least ${error.requiredLength} characters long.`,
    maxlength: (fieldName, error) => `${fieldName} cannot exceed ${error.requiredLength} characters.`,
    invalidDateRange: () => 'End date must be after start date.',
    invalidDateConsult: () => 'Last consulted date must be before class absence end date.',
    invalidDateSpan: () => 'Invalid date span.',
    mask: (fieldName) => `${fieldName} format is not valid.`,
    ngbDate: (fieldName, errors) => {
        const dateErrorObject = errors;

        if (dateErrorObject.hasOwnProperty('minDate')) {
            const minDateSet = dateErrorObject.minDate.minDate;
            const minDate = `${minDateSet.month}/${minDateSet.day}/${minDateSet.year}`;
            return `Date cannot be less than ${minDate}`;
        } else if (dateErrorObject.hasOwnProperty('maxDate')) {
            const maxDateSet = dateErrorObject.maxDate.maxDate;
            const maxDate = `${maxDateSet.month}/${maxDateSet.day}/${maxDateSet.year}`;
            return `Date cannot be greater than ${maxDate}`;
        } else if (dateErrorObject.hasOwnProperty('invalid')) {
            return `${fieldName} entered is not valid`;
        }
        return '';
    },
    invalidZipCode: (fieldName, error) => {
        return `Invalid ${fieldName} for ${error.ISO3}`;
    },
    invalidEmail: (fieldName, error) => {
        return `${fieldName} format is not valid`;
    },
    invalidPhone: (fieldName) => `${fieldName} format is not valid`,
    valueMustBeTrue: (fieldName) => `${fieldName} must be true`,
    signatureNotAccepted: (fieldName) => `When finished signing, please select 'Accept Signature'`,
};

@Injectable({
    providedIn: 'root',
})
export class FieldErrorService {
    getErrorMessage(fieldName: string, errors: any): string {
        for (const errorType of Object.keys(errors)) {
            if (ERROR_MESSAGES[errorType]) {
                return ERROR_MESSAGES[errorType](fieldName, errors[errorType]);
            }
        }
        return '';
    }
}
